const deliveryRCFieldGroups = {
  mandatory: [
    'docket_number',
    'plant',
    'arriving_date',
    'recipe',
    'delivered',
    'manufacture_time',
    'limit_time',
    'concrete_id',
  ],
  other: [
    'compound',
    'relation_wc',
    'admixtures_id',
    'admixtures_quantity',
    'admixtures_extra',
    'delivery_company',
    'truck',
    'driver',
    'delivery_company_cif',
  ],
};

const deliveryPCFieldGroups = {
  mandatory: [
    'docket_number',
    'arriving_date',
    'recipe',
    'delivered',
    'concrete_id',
  ],
  other: [
    'plant',
    'manufacture_time',
    'limit_time',
    'compound',
    'relation_wc',
    'admixtures_id',
    'admixtures_quantity',
    'admixtures_extra',
    'delivery_company',
    'truck',
    'driver',
    'delivery_company_cif',
  ],
};

export { deliveryPCFieldGroups, deliveryRCFieldGroups };
